import { render, staticRenderFns } from "./E-book.vue?vue&type=template&id=3f7c5d1c"
import script from "./E-book.vue?vue&type=script&lang=js"
export * from "./E-book.vue?vue&type=script&lang=js"
import style0 from "./E-book.vue?vue&type=style&index=0&id=3f7c5d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports